import { useState } from "react";
import { MainWrapper } from "../../common/MainWrapper";
import { StyledTable, TableWrapper, StyledMainTitle, StyledH2 } from "../styled";
import Header from "../../common/Header";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import ArchLastDay from "../../common/ArchLastDay/index.js";
import ArchDatesLastStatment from "../../common/ArchDatesLastStatment";
import {
  StyledParagraph
} from "../../common/ArchLastDay/styled";
import "../../style.css";
import ScrollButton from "../scrollButton";
import TodayDate from "../../common/todayDate";
import { BackToArchPanel } from "../../common/BackToArchPanel";
import { ArchUseResult } from "../../common/archUseResult";
import { baseUrl } from "../../common/apiUrl";

const ArchResult = () => {
  const navigate = useNavigate();
  const [data1, setData1] = useState("");
  const [data2, setData2] = useState("");
  const item = ArchUseResult({ data1, data2 });
  const [bonus_percentage, setBonus_Percentage] = useState(0.0);
  const [extra_amount, setExtra_Amount] = useState(0.0);

  const [dateLastStatment, setDateLastStatment] = useState(false);
  const [isSubmitForm, setIsSubmitForm] = useState(false);

  const handleChangeData1 = (e) => {
    setData1(e.target.value);
  };

  const handleChangeData2 = (e) => {
    setData2(e.target.value);
  };

  const handleChangeBox = ({ target }) => {
    setDateLastStatment(target.checked);
  };

  const handleChangeBonus = (e) => {
    setBonus_Percentage(e.target.value);
  };

  const handleChangeExtraAmount = (e) => {
    setExtra_Amount(e.target.value);
  };

  const submitForm = (e) => {
    e.preventDefault();
    setIsSubmitForm(true);

    const datesLastStatment = {
      data1: data1,
      data2: data2,
      dateLastStatment: dateLastStatment,
      bonus_percentage: bonus_percentage,
      extra_amount: extra_amount,
    };

    axios
      .post(`${baseUrl}/archInsLastStatment.php`, datesLastStatment)
      .then((result) => {
        if (result.data.Status === "Invalid") {
          alert("Invalid Data");
        } else {
          navigate("/archresult");
        }
      });
  };

  let totalRegularHours = 0;
  let regularHoursRate = 0;
  let erningFromRegularHours = 0;

  let totalOperatorHours = 0;
  let operatorHoursRate = 0;
  let erningFromOperatorHours = 0;

  let totalOperatorHoursWeekend = 0;
  let operatorHoursWeekendRate = 0;
  let erningFromOperatorHoursWeekend = 0;

  let totalRegularHoursWeekend = 0;
  let regularHoursWeekendRate = 0;
  let erningFromRegularHoursWeekend = 0;

  

  

  let totalHours = 0;
  let totalErn = 0.0;
  let bonusAmount = 0.0;
  // let parsedExtraAmount = 0.00;
  let totalErnWithBonus = 0.0;

  const parsedExtraAmount = parseFloat(extra_amount);

  const FormattedData1 = moment(data1).locale("en-gb").format("YYYY-MM-DD");
  const FormattedData2 = moment(data2).locale("en-gb").format("YYYY-MM-DD");

  return (
    <>
      <Header />
      <ScrollButton />
      <MainWrapper>
        <StyledMainTitle>Archiwum</StyledMainTitle>
        <StyledH2>Zestawienie - wybierz daty</StyledH2>
        <div className="container">
          <form onSubmit={submitForm}>
            <StyledTable>
              <tbody>
                <tr>
                  <td className="float-end me-2 text-primary p-2">
                    Data od: </td>
                  <td>
                    <input
                      type="date"
                      className="form-control m-1"
                      name="data1"
                      id="data1"
                      onChange={handleChangeData1}
                      value={data1}
                      required
                    />
                  </td>
                </tr>
                <tr>
                  <td className="float-end me-2 text-primary p-2">Data do: </td>
                  <td>
                    <input
                      type="date"
                      className="form-control m-1"
                      name="data2"
                      id="data2"
                      onChange={handleChangeData2}
                      value={data2}
                      required
                    />
                  </td>
                </tr>
                <tr>
                  <td className="float-end me-2 text-primary p-2">
                    Dodaj bonus procentowy:&nbsp;
                  </td>
                  <td>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control m-1"
                      name="bonus_percentage"
                      id="bonus_percentage"
                      title="Wprowadź liczbę w formacie: 10.00"
                      inputMode="decimal"
                      onChange={handleChangeBonus}
                      value={bonus_percentage}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="float-end me-2 text-primary p-2">
                    Bonus kwotowy:&nbsp;
                  </td>
                  <td>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control m-1"
                      name="extra_amount"
                      id="extra_amount"
                      title="Wprowadź liczbę w formacie: 10.00"
                      inputMode="decimal"
                      onChange={handleChangeExtraAmount}
                      value={extra_amount}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="float-end text-primary p-2">
                    Zapisz raport:&nbsp;
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      className="form-check-input float-start m-1"
                      name="dateLastStatment"
                      checked={dateLastStatment}
                      onChange={handleChangeBox}
                    />
                  </td>
                </tr>
              </tbody>
            </StyledTable>

            <TableWrapper>
              <button
                type="submit"
                name="submit"
                className="btn btn-primary btn-lg m-2"
                disabled={isSubmitForm}
              >
                {isSubmitForm ? "Done!" : "Show Result"}
              </button>
              <button
                type="reset"
                className="btn btn-primary btn-lg m-2"
                onClick={(e) => window.location.reload()}
              >
                Wyczyść dane
              </button>
            </TableWrapper>
          </form>
        </div>
        <BackToArchPanel />
        <ArchLastDay />
        <ArchDatesLastStatment />
        {isSubmitForm && (
          <>
            <p className="onlyPrint__header">
              WTR - Working Time Records
              <br />
              <small>Radek Bubienko</small>
            </p>
            <p className="statment__from no-wrap">
              Zestawienie od:
              <br />
              <b>{FormattedData1}</b> do <b>{FormattedData2}</b>
            </p>
            <TableWrapper>
              <table className="table table-dark table-striped table-bordered table-modified">
                <thead>
                  <tr>
                    <td>Data</td>
                    <td>Zmiana</td>
                    <td>
                      Godziny
                      <br />
                      pracy
                    </td>
                    <td>
                      Stawka
                      <br />
                      za godzinę
                    </td>
                    <td>
                      Dzienny
                      <br />
                      zarobek
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {item.map((item) => {
                    const FormattedDataPracy = moment(item.data_pracy)
                      .locale("en-gb")
                      .format("YYYY.MM.DD - dddd");

                    const parseIlGodz = parseFloat(item.il_godzin);
                    
                    if (
                      item.typ_stawki === "regular" &&
                      item.data_od === "2016-09-22"
                    ) {
                      totalRegularHours += parseIlGodz;
                      regularHoursRate = item.stawka;
                      erningFromRegularHours =
                        totalRegularHours * regularHoursRate;
                    }

                    if (
                      item.typ_stawki === "regular" &&
                      item.data_od === "2018-10-01"
                    ) {
                      totalRegularHours += parseIlGodz;
                      regularHoursRate = item.stawka;
                      erningFromRegularHours =
                        totalRegularHours * regularHoursRate;
                    }

                    if (
                      item.typ_stawki === "regular" &&
                      item.data_od === "2021-08-01"
                    ) {
                      totalRegularHours += parseIlGodz;
                      regularHoursRate = item.stawka;
                      erningFromRegularHours =
                        totalRegularHours * regularHoursRate;
                    }

                    if (
                      item.typ_stawki === "regular" &&
                      item.data_od === "2022-01-01"
                    ) {
                      totalRegularHours += parseIlGodz;
                      regularHoursRate = item.stawka;
                      erningFromRegularHours =
                        totalRegularHours * regularHoursRate;
                    }

                    if (
                      item.typ_stawki === "operator" &&
                      item.data_od === "2022-01-01"
                    ) {
                      totalOperatorHours += parseIlGodz;
                      operatorHoursRate = item.stawka;
                      erningFromOperatorHours =
                        totalOperatorHours * operatorHoursRate;
                    }

                    if (
                      item.typ_stawki === "operator weekend" &&
                      item.data_od === "2022-01-01"
                    ) {
                      totalOperatorHoursWeekend += parseIlGodz;
                      operatorHoursWeekendRate = item.stawka;
                      erningFromOperatorHoursWeekend =
                        totalOperatorHoursWeekend * operatorHoursWeekendRate;
                    }

                    if (item.typ_stawki === "regular weekend" &&
                      item.data_od === "2018-10-01"
                    ) {
                      totalRegularHoursWeekend += parseIlGodz;
                      regularHoursWeekendRate = item.stawka;
                      erningFromRegularHoursWeekend =
                        totalRegularHoursWeekend * regularHoursWeekendRate;
                    }

                    if (item.typ_stawki === "regular weekend" &&
                      item.data_od === "2021-08-01"
                    ) {
                      totalRegularHoursWeekend += parseIlGodz;
                      regularHoursWeekendRate = item.stawka;
                      erningFromRegularHoursWeekend =
                        totalRegularHoursWeekend * regularHoursWeekendRate;
                    }

                    totalHours =
                      totalRegularHours +
                      totalOperatorHours +
                      totalOperatorHoursWeekend +
                      totalRegularHoursWeekend;
                      
                    totalErn =
                      erningFromRegularHours +
                      erningFromOperatorHours +
                      erningFromRegularHoursWeekend +
                      erningFromOperatorHoursWeekend;
                      

                    bonusAmount = (totalErn * bonus_percentage) / 100;

                    totalErnWithBonus =
                      bonusAmount + totalErn + parsedExtraAmount;

                    return (
                      <tr key={item.id_daty}>
                        <td>{FormattedDataPracy}</td>
                        <td>{item.zmiana}</td>
                        <td>{item.il_godzin}</td>
                        <td>
                          {item.typ_stawki} - {item.stawka} PLN
                        </td>
                        <td>{item.il_godzin * item.stawka} PLN</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </TableWrapper>
            <StyledParagraph className="mb-2">
              Ilość godzin pracy:
              <br /> od <b>{FormattedData1}</b> do <b>{FormattedData2}</b>
            </StyledParagraph>
            {totalRegularHours > 0 ? (
              <StyledParagraph>
                Ilość godzin normalnych:
                <br /> {totalRegularHours.toFixed(1)} h x&nbsp;
                {regularHoursRate} PLN = {erningFromRegularHours.toFixed(2)}{" "}
                PLN.
              </StyledParagraph>
            ) : null}
            
            
            {totalOperatorHours > 0 ? (
              <StyledParagraph>
                Ilość godzin operatora:
                <br />
                {totalOperatorHours.toFixed(1)} h x&nbsp;{operatorHoursRate} PLN
                =&nbsp;
                {erningFromOperatorHours.toFixed(2)} PLN.
              </StyledParagraph>
            ) : null}
            
            {totalOperatorHoursWeekend > 0 ? (
              <StyledParagraph>
                Ilość godzin weekendowych:
                <br />
                {totalOperatorHoursWeekend.toFixed(1)} h x&nbsp;
                {operatorHoursWeekendRate} PLN =&nbsp;
                {erningFromOperatorHoursWeekend.toFixed(2)} PLN.
              </StyledParagraph>
            ) : null}
            
            
            {totalHours > 0 ? (
              <StyledParagraph>
                <br />
                Razem ilość godzin: <b>{totalHours.toFixed(1)}</b> h.
              </StyledParagraph>
            ) : null}
            {totalErn > 0 ? (
              <StyledParagraph>
                Razem do wyplaty: <b>{totalErn.toFixed(2)}</b> PLN/netto.
                <br />
              </StyledParagraph>
            ) : null}
            {extra_amount > 0 ? (
              <StyledParagraph>
                Dodatkowa kwota bonusu: <br />
                <b>{parsedExtraAmount.toFixed(2)}</b> PLN/netto.
                <br />
              </StyledParagraph>
            ) : null}
            {bonus_percentage > 0 ? (
              <StyledParagraph>
                Bonus <b>{bonus_percentage}</b>% ={" "}
                <b>{bonusAmount.toFixed(2)}</b> PLN/netto.
              </StyledParagraph>
            ) : null}
            {bonus_percentage > 0 || extra_amount > 0 ? (
              <StyledParagraph>
               Do zapłaty z bonusem:
                <br /> <b>{totalErnWithBonus.toFixed(2)}</b>
                PLN/netto.
              </StyledParagraph>
            ) : null}
          </>
        )}

        {totalErn > 0 ? (
          <>
            <div className="container-fluid d-print-none">
              <div className="row justify-content-center">
                <button
                  className="btn btn-primary btn-lg mt-3 m-2 col-md-2"
                  onClick={() => window.print()}
                >
                  Drukuj
                </button>


              </div>
            </div>
          </>
        ) : null}

        <div className="printDate">
          <TodayDate />
        </div>
      </MainWrapper>
    </>
  );
};

export default ArchResult;
